'use client';
import type { FC } from 'react';
import { css, cva } from '@styled-system/css';

export type FollowButtonState =
  | 'follow-back'
  | 'followed-by-me'
  | 'not-followed-by-me';

type FollowUnfollowButtonConfig = Partial<{
  smallRightAligned: boolean;
  canUnfollow: boolean;
}>;

interface Props {
  state: FollowButtonState;
  config?: FollowUnfollowButtonConfig;
  onClick?: () => void;
}

export const FollowUnfollowButton: FC<Props> = ({ state, config, onClick }) => {
  const label = (() => {
    switch (state) {
      case 'followed-by-me':
        return 'フォロー中';
      case 'follow-back':
        return 'フォロー返し';
      case 'not-followed-by-me':
        return 'フォロー';
    }
  })();
  const variant = (() => {
    switch (state) {
      case 'followed-by-me':
        return 'following';
      case 'follow-back':
        return 'isFollowBack';
      case 'not-followed-by-me':
        return 'follow';
    }
  })();
  const disabled = (() => {
    return state === 'followed-by-me' && config?.canUnfollow !== true;
  })();

  return (
    <>
      <button
        onClick={onClick}
        disabled={disabled}
        className={css(
          baseButtonStyle.raw({
            status: variant,
            location: config?.smallRightAligned
              ? 'smallRightAligned'
              : undefined,
          }),
          css.raw({
            cursor: disabled ? 'not-allowed' : 'pointer',
          })
        )}
      >
        {label}
      </button>
    </>
  );
};

const baseButtonStyle = cva({
  base: {
    animation: 'fadein 200ms ease-in',
    lineHeight: '1.15',
    textAlign: 'center',
    verticalAlign: 'middle',
    padding: '5px 15px',
    borderRadius: '2em',
    height: '36px',
    width: '120px',
    fontSize: 'size_12',
    fontWeight: '700',
    minWidth: '130px',
    cursor: 'pointer',
  },
  variants: {
    status: {
      follow: {
        color: 'white',
        backgroundColor: 'tint',
      },
      following: {
        color: 'accent.1000',
        backgroundColor: 'primary',
        border: '1px solid #313238',
      },
      isFollowBack: {
        color: 'white',
        backgroundColor: 'tint',
        fontSize: {
          lg: 'size_12',
        },
      },
    },
    location: {
      smallRightAligned: {
        marginLeft: 'auto',
        width: {
          lg: '120px',
          base: '105px',
        },
        minWidth: {
          lg: '120px',
          base: '110px',
        },
        height: {
          lg: '36px',
          base: '28px',
        },
        fontWeight: {
          lg: 'normal',
        },
        padding: {
          base: '8px 10px',
          lg: '8px',
        },
        marginRight: {
          base: '8px',
        },
      },
    },
  },
});
